<gen-notes class="gen-aberration-notes"
  [actorType]="'Practitioner'"
  [actorId]="authService.user.info.id"
  [contextType]="'Aberration'"
  [contextId]="aberrationId"
  [newNotes]="false"
  [filters]="false"
  (noteAddedEmit)="onNoteAdded($event)"
></gen-notes>
